import { atom } from 'jotai'

export const isPageLoadingState = atom<{
  isLoading: boolean
  message?: string
  hideSpinner?: boolean
}>({
  isLoading: false,
})
